<!-- Analiz Modu Seçimi -->
<div style="display: flex;gap: 4px;margin-bottom: 0.4rem;">
    <button class="ui mini button"
            [class.purple]="analizModu === 'PRO_GPU'"
            [class.basic]="analizModu !== 'PRO_GPU'"
            (click)="analizModu = 'PRO_GPU'; CD.detectChanges();"
            [disabled]="analizAktif"
            style="flex: 1;padding: 0.3rem;font-size: 0.65rem;">
        <i class="gem icon"></i> PRO
    </button>
    <button class="ui mini button"
            [class.green]="analizModu === 'GPU'"
            [class.basic]="analizModu !== 'GPU'"
            (click)="analizModu = 'GPU'; CD.detectChanges();"
            [disabled]="analizAktif"
            style="flex: 1;padding: 0.3rem;font-size: 0.65rem;">
        <i class="microchip icon"></i> GPU
    </button>
    <button class="ui mini button"
            [class.blue]="analizModu === 'CPU'"
            [class.basic]="analizModu !== 'CPU'"
            (click)="analizModu = 'CPU'; CD.detectChanges();"
            [disabled]="analizAktif"
            style="flex: 1;padding: 0.3rem;font-size: 0.65rem;">
        <i class="server icon"></i> CPU
    </button>
</div>

<!-- CPU İlerleme Göstergesi -->
@if (cpuHesaplaniyor) {
    <div style="background: rgba(33, 133, 208, 0.2);padding: 0.3rem;border-radius: 4px;margin-bottom: 0.4rem;border: 1px solid rgba(33, 133, 208, 0.4);">
        <div style="display: flex;align-items: center;gap: 6px;">
            <i class="spinner loading icon" style="color: #2185d0;font-size:0.7rem;"></i>
            <span style="font-size: 0.65rem;color: #fff;">BVH Ray Casting...</span>
            <span style="font-size: 0.65rem;color: #2185d0;margin-left: auto;">%{{cpuIlerleme}}</span>
        </div>
        <div style="height: 3px;background: rgba(255,255,255,0.1);border-radius: 2px;overflow: hidden;margin-top:3px;">
            <div [style.width.%]="cpuIlerleme"
                 style="height: 100%;background: #2185d0;transition: width 0.2s;"></div>
        </div>
    </div>
}

<!-- Kritik Kalınlık -->
<div style="background: rgba(244, 67, 54, 0.1);padding: 0.3rem;border-radius: 4px;border: 1px solid rgba(244, 67, 54, 0.3);margin-bottom:0.4rem;">
    <div style="display: flex;gap: 6px;align-items: center;">
        <span style="font-size:0.6rem;color:#f8aba9;white-space:nowrap;">Kritik:</span>
        <input type="number"
               [(ngModel)]="kritikKalinlik"
               (change)="shaderParametreleriniGuncelle()"
               step="0.1" min="0"
               style="flex:1;padding:4px;border-radius:3px;border:1px solid #666;background:#333;color:white;font-size:0.75rem;text-align:center;max-width:70px;">
        <span style="font-size:0.6rem;color:#888;">mm</span>
        <div class="ui toggle checkbox" style="transform: scale(0.7);transform-origin: right;">
            <input type="checkbox" [(ngModel)]="highlightCritical" (change)="shaderParametreleriniGuncelle()">
            <label style="color: white;font-size: 0.55rem;"></label>
        </div>
    </div>
</div>

<!-- Renk Skalası Gradient -->
<div style="height: 20px;border-radius: 3px;margin-bottom: 0.25rem;display: flex;overflow: hidden;border: 1px solid #444;">
    @for (item of renkSkalasi; track $index; let i = $index) {
        @if (i < renkSkalasi.length - 1) {
            <div [style.background]="'linear-gradient(to right, ' + item.renk + ', ' + renkSkalasi[i + 1].renk + ')'"
                 [style.flex]="renkSkalasi[i + 1].kalinlik - item.kalinlik"
                 style="height: 100%;"></div>
        }
    }
</div>
<div style="display: flex;justify-content: space-between;font-size: 0.55rem;color: #aaa;margin-bottom: 0.3rem;">
    @for (item of renkSkalasi; track $index) {
        <span>{{item.kalinlik}}</span>
    }
</div>

<!-- Renk Noktaları (Collapsible) -->
<details style="margin-bottom: 0.3rem;">
    <summary style="font-size: 0.65rem;color: #aaa;cursor: pointer;padding: 0.2rem;">
        <i class="paint brush icon"></i> Renk Noktaları ({{renkSkalasi.length}})
    </summary>
    <div style="background: rgba(0,0,0,0.2);padding: 0.3rem;border-radius: 4px;max-height: 150px;overflow-y: auto;margin-top:0.2rem;">
        @for (item of renkSkalasi; track $index; let i = $index) {
            <div style="display: flex;align-items: center;gap: 4px;margin-bottom: 4px;">
                <input type="color" [value]="item.renk" (input)="renkSkalaDegisti(i, 'renk', $event.target.value)"
                       style="width: 28px;height: 22px;border: none;cursor: pointer;border-radius: 3px;">
                <input type="number" [value]="item.kalinlik" (change)="renkSkalaDegisti(i, 'kalinlik', $event.target.value)"
                       step="0.1" min="0"
                       style="width: 55px;padding: 3px;border-radius: 3px;border: 1px solid #555;background: #333;color: white;font-size: 0.7rem;text-align: center;">
                <button class="ui mini icon button" (click)="renkSkalaSil(i)" [disabled]="renkSkalasi.length <= 2"
                        style="padding: 3px 5px;"><i class="trash icon" style="font-size: 0.6rem;"></i></button>
            </div>
        }
        <div style="display:flex;gap:4px;margin-top:4px;">
            <button class="ui mini button" (click)="renkSkalaEkle()" [disabled]="renkSkalasi.length >= 8"
                    style="flex:1;padding: 0.25rem;font-size: 0.6rem;">
                <i class="plus icon"></i> Ekle
            </button>
            <button class="ui mini teal button" (click)="otomatikSkalaHesapla()" [disabled]="!sonuclar"
                    style="flex:1;padding: 0.25rem;font-size: 0.6rem;">
                <i class="magic icon"></i> Otomatik
            </button>
        </div>
    </div>
</details>

<!-- PRO Ayarları (Collapsible) -->
@if (analizModu === 'PRO_GPU') {
    <details open style="margin-bottom: 0.3rem;">
        <summary style="font-size: 0.65rem;color: #ce93d8;cursor: pointer;padding: 0.2rem;">
            <i class="gem icon"></i> PRO Ayarları
        </summary>
        <div style="background: rgba(156, 39, 176, 0.1);padding: 0.3rem;border-radius: 4px;margin-top:0.2rem;">
            <!-- Renk Preseti -->
            <div style="display: flex;flex-wrap: wrap;gap: 3px;margin-bottom: 0.3rem;">
                <button class="ui mini button" [class.purple]="renkPreseti === 'ct_scan'" [class.basic]="renkPreseti !== 'ct_scan'"
                        (click)="renkPresetiDegistir('ct_scan')" style="padding: 0.25rem 0.4rem;font-size: 0.55rem;">CT-Scan</button>
                <button class="ui mini button" [class.orange]="renkPreseti === 'thermal'" [class.basic]="renkPreseti !== 'thermal'"
                        (click)="renkPresetiDegistir('thermal')" style="padding: 0.25rem 0.4rem;font-size: 0.55rem;">Termal</button>
                <button class="ui mini button" [class.pink]="renkPreseti === 'rainbow'" [class.basic]="renkPreseti !== 'rainbow'"
                        (click)="renkPresetiDegistir('rainbow')" style="padding: 0.25rem 0.4rem;font-size: 0.55rem;">Gökkuşağı</button>
                <button class="ui mini button" [class.yellow]="renkPreseti === 'industrial'" [class.basic]="renkPreseti !== 'industrial'"
                        (click)="renkPresetiDegistir('industrial')" style="padding: 0.25rem 0.4rem;font-size: 0.55rem;">Endüstriyel</button>
            </div>
            <!-- SSS & Edge Glow -->
            <div style="display: flex;gap: 8px;align-items:center;">
                <div class="ui toggle checkbox" style="transform: scale(0.65);transform-origin: left;">
                    <input type="checkbox" [(ngModel)]="sssEnabled" (change)="sssAyarlariGuncelle()">
                    <label style="color: white;font-size: 0.55rem;white-space:nowrap;">SSS</label>
                </div>
                @if (sssEnabled) {
                    <input type="range" [(ngModel)]="sssIntensity" (input)="sssAyarlariGuncelle()"
                           min="0" max="1" step="0.05" style="flex: 1;height:12px;">
                    <span style="font-size: 0.55rem;color: #ffb74d;">{{(sssIntensity * 100).toFixed(0)}}%</span>
                }
            </div>
        </div>
    </details>
}

<!-- Kontrol Butonları -->
<div style="display: flex;gap: 4px;margin-bottom: 0.3rem;">
    <button class="ui mini button" (click)="varsayilanDegerleriYukle()" style="padding: 0.25rem 0.4rem;font-size: 0.6rem;">
        <i class="undo icon"></i> Sıfırla
    </button>
    <div style="flex:1;"></div>
    @if (!analizAktif) {
        <button class="ui mini green button" (click)="analiziBaslat()" style="padding: 0.25rem 0.5rem;">
            <i class="play icon"></i> Başlat
        </button>
    }
    @if (analizAktif) {
        <button class="ui mini red button" (click)="analiziDurdur()" style="padding: 0.25rem 0.5rem;">
            <i class="stop icon"></i> Durdur
        </button>
    }
</div>

<!-- Sonuçlar (Compact) -->
@if (sonuclar) {
    <div style="background: rgba(0,100,0,0.15);padding: 0.25rem;border-radius: 4px;font-size: 0.6rem;">
        <div style="display: flex;justify-content:space-between;color:#aaa;">
            <span>Min: <b style="color:#ef5350;">{{sonuclar.minBulunan.toFixed(2)}}mm</b></span>
            <span>Max: <b style="color:#66bb6a;">{{sonuclar.maxBulunan.toFixed(2)}}mm</b></span>
            <span>Ort: <b style="color:#42a5f5;">{{sonuclar.ortalamaKalinlik.toFixed(2)}}mm</b></span>
        </div>
        @if (sonuclar.kritikYuzde > 0) {
            <div style="color: #ff6666;margin-top:2px;">Kritik: %{{sonuclar.kritikYuzde.toFixed(1)}}</div>
        }
    </div>
}

<!-- Histogram (Collapsible) -->
@if (gelismisIstatistikler && gelismisIstatistikler.histogram && gelismisIstatistikler.histogram.length > 0) {
    <details style="margin-top: 0.3rem;">
        <summary style="font-size: 0.6rem;color: #b39ddb;cursor: pointer;padding: 0.2rem;">
            <i class="chart bar icon"></i> Kalınlık Dağılımı
        </summary>
        <div style="display: flex;align-items: flex-end;height: 40px;gap: 1px;background: rgba(0,0,0,0.2);padding: 3px;border-radius: 3px;margin-top:0.2rem;">
            @for (bar of gelismisIstatistikler.histogram; track $index; let i = $index) {
                <div [style.height.%]="bar.count"
                     [style.background]="getHistogramColor(i, gelismisIstatistikler.histogram.length)"
                     style="flex: 1;min-width: 2px;border-radius: 1px 1px 0 0;"
                     [title]="getHistogramTooltip(i, gelismisIstatistikler)"></div>
            }
        </div>
        <div style="display: flex;justify-content: space-between;font-size: 0.5rem;color: #888;margin-top: 2px;">
            <span>{{gelismisIstatistikler.minThickness.toFixed(1)}}mm</span>
            <span>{{gelismisIstatistikler.maxThickness.toFixed(1)}}mm</span>
        </div>
        <button class="ui mini purple button fluid" (click)="exportJSON()" style="margin-top: 0.3rem;padding: 0.25rem;font-size: 0.55rem;">
            <i class="download icon"></i> JSON Dışa Aktar
        </button>
    </details>
}
